import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=004dc69c&scoped=true&"
import script from "./CustomerInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfo.vue?vue&type=style&index=0&id=004dc69c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004dc69c",
  null
  
)

export default component.exports